import {Component, OnInit} from '@angular/core';
import {StepComponent} from "../../step/step.component";
import {Step, StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {HeizcheckRequestService} from "../services/heizcheck-request.service";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {HeizcheckAnfrage} from "../anfrage/heizcheck.anfrage";
import {VerbrauchsanalyseHeizcheckForm} from "./verbrauchsanalyse.heizcheck.form";
import {EnergyMapService} from "../../energy-map/services/energy.map.service";
import {Subscription} from "rxjs";
import {HeizcheckConstants} from "../heizcheck.constants";

/**
 * INput section of the heizcheck advisor.
 *
 * @inheritDoc
 */
@Component({
    selector: 'app-step-verbrauchsanalyse',
    templateUrl: '../../step/step.component.html',
    standalone: false
})
export class VerbrauchsanalyseStepComponent extends StepComponent implements OnInit{

  /**
   * (input) data of the user
   */
  anfrage: HeizcheckAnfrage;

  /**
   * @inheritDoc
   */
  formConfig: VerbrauchsanalyseHeizcheckForm;

  /**
   * Overwrite the label prefix.
   */
  textkeyPrefix: string = "heizcheck";

  /**
   * @inheritDoc
   * @param stepService
   * @param router
   * @param requestService
   * @param elementService
   * @param portalService
   * @param energyMapService
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: HeizcheckRequestService, protected elementService: ElementService,
              protected portalService: PortalService, protected energyMapService: EnergyMapService) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    // add the correct form config that we need in this steps and init the parent form
    this.formConfig = new VerbrauchsanalyseHeizcheckForm(this.energyMapService);
    super.ngOnInit();

    // get the current input data and preset it
    this.anfrage = this.requestService.getAnfrage();
    this.formConfig.setData(this.anfrage.verbrauchsanalyseInput);
    this.formConfig.anfrage = this.anfrage;

    // update the previous step
    this.onStepUpdate();

    // init error placeholder
    this.initErrorPlaceholder();
  }

  /**
   * @inheritDoc
   * @param data
   */
  saveData(data:{[key: string]: any}) {
    // merge the data with the existing data
    this.anfrage.verbrauchsanalyseInput = {...this.anfrage.verbrauchsanalyseInput, ...data};
    this.requestService.setAnfrage(this.anfrage);

    // save the data also to the server
    this.requestService.saveDataToServer();

    super.saveData(data);
  }

  /**
   * Return the next step from a step list
   * @param stepList
   */
  getNextStepFromList(stepList: Step[]): any {
    // set all data again in the form to avoid using old data for toggle fields
    if(this.anfrage?.verbrauchsanalyseInput && this.formConfig) {
      this.formConfig.updateFields(this.anfrage.verbrauchsanalyseInput);
      // save the data again. In some case some fields are autoupdatetd
      this.saveData({});
    }

    return super.getNextStepFromList(stepList);
  }

  /**
   * @inheritDoc
   */
  onStepUpdate() {
    super.onStepUpdate();

    // change the pagehelptext for some cases here
    if(this.steps.currentStep.name === 'heizsystem/1' && (this.anfrage?.verbrauchsanalyseInput?.nutzungstyp === 'mieter' || this.anfrage?.verbrauchsanalyseInput?.nutzungstyp === 'wohnungseigentuemer') &&
      this.anfrage?.verbrauchsanalyseInput?.heizungstyp !== 'zentral') {
      this.helpTextkey += '.wohnung';
    }

    // set last step on first input of base data in energy bill path
    if(this.steps?.currentStep?.name === 'basisinformationen/1') {
      this.previousStep = new Step('heizungstyp', '../../../einstieg/heizungstyp');
    }
  }

  /**
   * inits placeholder for error messages
   */
  initErrorPlaceholder(): void {
    if(this.form?.controls['anzahl_wohneinheiten']) {
      this.subscriptions.push(this.form?.controls['anzahl_wohneinheiten']?.valueChanges?.subscribe((value) => {
        const averageSize = Math.round(this.anfrage.verbrauchsanalyseInput.gebaeude_flaeche / value);
        if (averageSize < HeizcheckConstants.APARTMENT_SIZE_MIN || averageSize > HeizcheckConstants.APARTMENT_SIZE_MAX) {
          this.stepErrorPlaceholder = {
            apartmentSize: averageSize,
            portalId: this.portalService?.currentPortalId
          }
        }
      }));
    }
  }

}
